/*
(C) Copyright 2015–2022 Potsdam Institute for Climate Impact Research (PIK), authors, and contributors, see AUTHORS file.

This file is part of vodle.

vodle is free software: you can redistribute it and/or modify it under the 
terms of the GNU Affero General Public License as published by the Free 
Software Foundation, either version 3 of the License, or (at your option) 
any later version.

vodle is distributed in the hope that it will be useful, but WITHOUT ANY 
WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR 
A PARTICULAR PURPOSE. See the GNU Affero General Public License for more 
details.

You should have received a copy of the GNU Affero General Public License 
along with vodle. If not, see <https://www.gnu.org/licenses/>. 
*/

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// the second half of the stopwatch index.html starts: how long the browser
// took to fetch, parse and run the bundle — everything above has already
// been evaluated when this line runs. Printed raw, because a deployment
// runs the logger at ERROR and would swallow it (#327).
console.log('[vodle boot] +'
  + (Date.now() - ((window as any).vodle_page_start || Date.now()))
  + 'ms the app bundle ran');

if (environment.production) {
  enableProdMode();
}

// zone-based change detection, which used to be the bootstrap's default and
// is a provider since Angular 21 (its update wrote this line). platformBrowser,
// not the deprecated platformBrowserDynamic: every build is ahead-of-time
// compiled now (angular.json), so no compiler ships with the app.
platformBrowser().bootstrapModule(AppModule, {applicationProviders: [provideZoneChangeDetection()]})
  .catch(err => console.log(err));
